<template lang='pug' src='./custom-braces-types.pug'></template>

<script>
export default {
  props: ['props'],
  data () {
    return {
      active: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-braces-types.vue?4d38b6f8